import { render, staticRenderFns } from "./NewSupplier.vue?vue&type=template&id=32eaee92&scoped=true"
import script from "./NewSupplier.vue?vue&type=script&lang=js"
export * from "./NewSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eaee92",
  null
  
)

export default component.exports